import React from 'react'
import c from 'classnames'
import { Link } from 'react-router-dom'

import style from './dropdown.module.sass'

export type Props = {
	title: React.ReactNode
	iconLink: string
	links?: {
		name: React.ReactNode
		to?: string
		onClick?: () => void
		active?: boolean
	}[]
	closeDropdown?: () => void
}

export default (props: Props) => {
	return (
		<>
			<Link to={props.iconLink} className={style.title}>{props.title}</Link>
			{props.links && props.links.map((link, i) => (
				<div
					key={i}
					onClick={() => {
						link.onClick && link.onClick()
						props.closeDropdown && props.closeDropdown()
					}}
				>
					{ link.to
						? (
							<Link
								className={c(style.link, {[style.active]: link.active})}
								to={link.to}
							>
								{link.name}
							</Link>
						) : (
							<div className={style.link}>
								{link.name}
							</div>
						)
					}
					
				</div>
			))}
		</>
	)
}
